import ekozAxios from './instance/axios';

export const readCategories = () => ekozAxios.request({
  method: 'get',
  url: '/categories/get_categories.php',
});
